<template>
  <svg
    width="15px"
    height="16px"
    viewBox="0 0 15 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>{{ title }}</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g id="Icon-/-Date-picker-active" stroke="#2F477C" stroke-width="1.4">
        <path
          id="Combined-Shape"
          d="M2.4,2.4 L12.6,2.4 C13.3731986,2.4 14,3.02680135 14,3.8 L14,13.6 C14,14.3731986 13.3731986,15 12.6,15 L2.4,15 C1.62680135,15 1,14.3731986 1,13.6 L1,3.8 C1,3.02680135 1.62680135,2.4 2.4,2.4 Z M10.3888889,1 L10.3888889,3.8 M4.61111111,1 L4.61111111,3.8 M1,6.6 L14,6.6"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    title: {
      type: String,
      default: 'Date Picker',
    },
  },
};
</script>
